<template>
    <div class="modal-overlay" v-if="isOpen" @click.self="close">
        <div class="modal-content iframe-modal">
            <div class="modal-header">
                <h2>{{ newIframe.id ? 'Editar Curso' : 'Criar Novo Curso (iFrame)' }}</h2>
                <button class="btn-close" @click="close"><i class="fas fa-times"></i></button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label>Nome do Curso na Plataforma:</label>
                    <input type="text" v-model="newIframe.nome" placeholder="Ex: Matemática Intensiva"
                        class="glass-input" />
                </div>

                <div class="form-group">
                    <label>
                        Tipo de Acesso
                        <div class="custom-tooltip-container">
                            <i class="fas fa-info-circle info-icon"></i>
                            <div class="custom-tooltip">Adicione os domínios que devem ser permitidos para assistir o
                                conteúdo. Se não tiverem domínios adicionados o iFrame fica liberado para todos.</div>
                        </div>
                    </label>
                    <select v-model="newIframe.restrictionType" class="glass-input">
                        <option value="all">Permitir Todos</option>
                        <option value="restricted">Domínios Autorizados</option>
                    </select>
                </div>

                <div class="form-group" v-if="newIframe.restrictionType === 'restricted'">
                    <div class="accordion-header" @click="isAcessosOpen = !isAcessosOpen">
                        <span><i class="fas fa-lock accordion-icon"></i> Acessos permitidos
                            ({{ newIframe.allowedDomainsList.length }})</span>
                        <i :class="[isAcessosOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down', 'accordion-icon']"></i>
                    </div>

                    <div class="accordion-body" v-if="isAcessosOpen">
                        <label class="accordion-label">Adicionar Domínio Autorizado</label>
                        <div class="domain-input-group">
                            <input type="text" v-model="domainInput" @keyup.enter.prevent="addDomain"
                                placeholder="Ex: colegio.com.br (pressione Enter)" class="glass-input flex-1" />
                        </div>

                        <div class="domain-list" v-if="newIframe.allowedDomainsList.length > 0">
                            <div class="domain-item" v-for="(domain, index) in newIframe.allowedDomainsList"
                                :key="index">
                                <span>{{ domain }}</span>
                                <button class="btn-remove-domain" @click.prevent="removeDomain(index)">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="materials-selection">
                    <h3>Selecione os materiais para este curso:</h3>
                    <p class="selection-desc">Apenas materiais com assinatura ativa estão disponíveis.</p>

                    <div class="materials-list">
                        <div v-for="assinatura in assinaturasAtivas" :key="'modal-' + assinatura.id"
                            class="material-checkbox-item">
                            <label class="custom-checkbox">
                                <input type="checkbox" :value="assinatura.codigo_disciplina"
                                    v-model="newIframe.materiaisSelecionados" />
                                <span class="checkmark"></span>
                                <span class="label-text">{{ assinatura.nome }}</span>
                            </label>
                        </div>
                        <div v-if="assinaturasAtivas.length === 0" class="empty-materials">
                            Você não possui nenhuma assinatura de material ativa no momento.
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn-action cancel" @click="close">Cancelar</button>
                <button class="btn-action pay" @click="save">{{ newIframe.id ? 'Salvar Alterações' : 'Gerar iFrame'
                    }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CourseModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        assinaturas: {
            type: Array,
            default: () => []
        },
        initialData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            domainInput: '',
            isAcessosOpen: false,
            newIframe: {
                id: null,
                nome: '',
                materiaisSelecionados: [],
                restrictionType: 'all',
                allowedDomainsList: []
            }
        };
    },
    computed: {
        assinaturasAtivas() {
            return this.assinaturas.filter(a => a.status === 'Ativo');
        }
    },
    watch: {
        isOpen: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    document.body.style.overflow = 'hidden';
                    this.domainInput = '';
                    this.isAcessosOpen = false;
                    if (this.initialData) {
                        const isRestricted = this.initialData.allowed_domains && this.initialData.allowed_domains.length > 0;
                        this.newIframe = {
                            id: this.initialData.id,
                            nome: this.initialData.nome,
                            materiaisSelecionados: this.initialData.materiaisSelecionados || [],
                            restrictionType: isRestricted ? 'restricted' : 'all',
                            allowedDomainsList: isRestricted ? [...this.initialData.allowed_domains] : []
                        };
                    } else {
                        this.newIframe = {
                            id: null,
                            nome: '',
                            materiaisSelecionados: [],
                            restrictionType: 'all',
                            allowedDomainsList: []
                        };
                    }
                } else {
                    document.body.style.overflow = '';
                }
            }
        }
    },
    beforeDestroy() {
        document.body.style.overflow = '';
    },
    methods: {
        close() {
            this.$emit('close');
        },
        save() {
            this.$emit('save', { ...this.newIframe });
        },
        addDomain() {
            if (!this.domainInput.trim()) return;
            let domain = this.domainInput.trim().toLowerCase();
            domain = domain.replace(/^https?:\/\//, '').split('/')[0].split(':')[0];

            if (domain && !this.newIframe.allowedDomainsList.includes(domain)) {
                this.newIframe.allowedDomainsList.push(domain);
            }
            this.domainInput = '';
        },
        removeDomain(index) {
            this.newIframe.allowedDomainsList.splice(index, 1);
        }
    }
}
</script>

<style scoped src="./CourseModal.css"></style>
